import { render, staticRenderFns } from "./SpoiledTricksButton.vue?vue&type=template&id=a6bd0e22&scoped=true&"
import script from "./SpoiledTricksButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledTricksButton.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledTricksButton.vue?vue&type=style&index=0&id=a6bd0e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd0e22",
  null
  
)

export default component.exports